exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".predicition-page .siteHeader{\n  margin-bottom: 0px !important;\n}\n", ""]);

// exports
